// extracted by mini-css-extract-plugin
export var cardSelected = "_hm-2";
export var image = "_hm-1";
export var table = "_hm-0";